export const limitByPage = 25

export default {
  limitByPage
}